import IconComponent from "icons/IconComponent";

import CarIcon from "./car.svg";

export default (CarIcon as any) as IconComponent;
